/* blocks */
import EventsPageHero from './components/EventsPageHero/EventsPageHero'
import UpcomingEvents from './components/UpcomingEvents/UpcomingEvents'
import PastEvents from './components/PastEvents/PastEvents'
import EventsOverview from './components/EventsOverview/EventsOverview'
import CustomerLogo from './components/CustomerLogo'
import Testimonials from '@/cmp/organism/Testimonials/Testimonials'
import EventsNewsletter from '@/cmp/organism/EventsNewsletter/EventsNewsletter'
import FooterCta from '@/cmp/organism/FooterCta/FooterCta'

/* utils */
import {
  IndividualEventsPageAttributes,
  EventsPageAttributes
} from '@/utils/queries/events-page'

/* styles */
import styles from './_.module.css'

interface Props {
  data: EventsPageAttributes
  individualEventsPage: IndividualEventsPageAttributes[]
}

function EventsPageTemplate({
  data,
  individualEventsPage
}: Props): JSX.Element {
  const upcomingEventsData = individualEventsPage.filter(
    data => data.eventType === 'Upcoming_Event'
  )
  const pastEventsData = individualEventsPage.filter(
    data => data.eventType === 'Past_Event' && data.showOnHomepage
  )

  return (
    <>
      <EventsPageHero
        title={data.heroTitle}
        description={data.heroDescription}
        heroCta={data.heroCta}
        heroMediaCarousel={data.heroMediaCarousel}
      />

      {upcomingEventsData.length > 0 ? (
        <UpcomingEvents
          title="Events To Look Out For"
          lists={upcomingEventsData}
          showViewMore={true}
        />
      ) : null}

      {pastEventsData.length > 0 ? (
        <PastEvents title="Pepper Event Archive" lists={pastEventsData} />
      ) : null}

      {data.eventOverviewInfluencerList.length > 0 ? (
        <EventsOverview
          title={data.eventsOverviewTitle}
          description={data.eventsOverviewDescription}
          statistics={data.eventsOverviewStats.map(i => ({
            stat: i.title ?? '',
            color: i.color,
            description: i.description ?? ''
          }))}
          influencerList={data.eventOverviewInfluencerList.map(i => ({
            name: i.title ?? '',
            designation: i.description ?? '',
            image: i.multimedia?.media?.data?.attributes
          }))}
        />
      ) : null}

      {data.brands ? (
        <CustomerLogo title={data.brands.title} brands={brands} />
      ) : null}

      {data.testimonialList.data.length > 0 ? (
        <Testimonials
          theme="light"
          title={data.testimonialTitle}
          class={styles.testimonial}
          testimonials={data.testimonialList.data.map(i => ({
            authorName: i.attributes.authorName,
            authorDesignation: i.attributes.authorDesignation,
            authorImage: i.attributes?.authorImage,
            company: i.attributes.company,
            companyImage: i.attributes?.companyImage,
            review: i.attributes.review
          }))}
        />
      ) : null}

      {data.eventNewsletterForm.title ? (
        <EventsNewsletter
          title={data.eventNewsletterForm.title ?? ''}
          description={data.eventNewsletterForm.description ?? ''}
          bgColor={data.eventNewsletterForm.color ?? ''}
          image={data.eventNewsletterForm.multimedia?.media?.data?.attributes}
        />
      ) : null}

      {data.footerCta.title ? (
        <FooterCta
          headline={data.footerCta.title}
          primaryCta={data.footerCta.primaryCta}
          secondaryCta={data.footerCta.secondaryCta}
          mode="full_width"
          variant="dark"
        />
      ) : null}
    </>
  )
}

// TODO: Remove the brands array agter the strapi issue is fixed
const brands = [
  {
    url: '/assets/icons/brands/blue-logos/google-blue.png',
    alternativeText: 'Google',
    height: 56,
    width: 128
  },
  {
    url: '/assets/icons/brands/blue-logos/hive-blue.png',
    alternativeText: 'Hive',
    height: 56,
    width: 128
  },
  {
    url: '/assets/icons/brands/blue-logos/inscribe-blue.png',
    alternativeText: 'Inscribe',
    height: 56,
    width: 128
  },
  {
    url: '/assets/icons/brands/blue-logos/jio-saavn-blue.png',
    alternativeText: 'Jio Saavn',
    height: 56,
    width: 128
  },
  {
    url: '/assets/icons/brands/blue-logos/justdial-blue.png',
    alternativeText: 'Justdial',
    height: 56,
    width: 128
  },
  {
    url: '/assets/icons/brands/blue-logos/kaspersky-blue.png',
    alternativeText: 'Kaspersky',
    height: 56,
    width: 128
  },
  {
    url: '/assets/icons/brands/blue-logos/kotak-blue.png',
    alternativeText: 'Kotak',
    height: 56,
    width: 128
  },
  {
    url: '/assets/icons/brands/blue-logos/meta-blue.png',
    alternativeText: 'Meta',
    height: 56,
    width: 128
  },
  {
    url: '/assets/icons/brands/blue-logos/oyo-blue.png',
    alternativeText: 'Oyo',
    height: 56,
    width: 128
  },
  {
    url: '/assets/icons/brands/blue-logos/P&G-blue.png',
    alternativeText: 'P&G',
    height: 56,
    width: 128
  },
  {
    url: '/assets/icons/brands/blue-logos/paytm-blue.png',
    alternativeText: 'Paytm',
    height: 56,
    width: 128
  },
  {
    url: '/assets/icons/brands/blue-logos/puma-blue.png',
    alternativeText: 'Puma',
    height: 56,
    width: 128
  },
  {
    url: '/assets/icons/brands/blue-logos/quick-heal-blue.png',
    alternativeText: 'Quick Heal',
    height: 56,
    width: 128
  },
  {
    url: '/assets/icons/brands/blue-logos/yelp-blue.png',
    alternativeText: 'Yelp',
    height: 56,
    width: 128
  },
  {
    url: '/assets/icons/brands/blue-logos/zee-blue.png',
    alternativeText: 'Zee',
    height: 56,
    width: 128
  }
]

export default EventsPageTemplate
